import React, {useContext, useEffect, useState} from "react";
import Api from "../../Api";
import {useParams} from "react-router-dom";
import {withAuth} from "../../hoc/Auth";
import {Column, Container, Wrapper} from "../../hoc/Layout";
import EmptyCard from "../../hoc/EmptyCard";
import PayControls from "../../Components/PayControls";
import {
    CardNumberInputHelper,
    InputAmountCurrencyHelper,
    InputHelper,
    Select
} from "../../Components/Utils/FieldsHelper";
import {FormattedMessage} from "react-intl";

import classes from "./styles.module.css";

import MessageContext from "../../MessageContext";

export default withAuth(({token}) => {

        const [projectUUID, setProjectUUID] = useState(useParams().uuid);
        const [providerUUID, setProviderUUID] = useState(null);

        const [projects, setProjects] = useState([]);
        const [terminals, setTerminals] = useState([]);
        const [selectedProject, setSelectedProject] = useState(null);
        const [selectedTerminal, setSelectedTerminal] = useState(null);

        const [totalFee, setTotalFee] = useState({fixedPerTransaction: 0, cost: 1, costFixedMinimum: 40});
        const [commission, setCommission] = useState(0);
        const [terminalBalance, setTerminalBalance] = useState({balance: 0, currency: "RUB"});

        const [form, setForm] = useState({pan: '', cardHolder: '', email: '', phone: '', amount: ''});

        const [loadingProjects, setLoadingProjects] = useState(true);
        const [loadingTerminals, setLoadingTerminals] = useState(false);

        const [isRequest, setIsRequest] = useState(false);

        const {onMessage} = useContext(MessageContext);

        useEffect(() => {

            new Api({token}).getProjects().then(
                function (r) {
                    setProjects(r);
                    setLoadingProjects(false)
                }
            );

        }, []);

        function calcCommission(amount, fee) {

            if (amount.length !== 0 && fee) {
                if ((Number(amount) * (fee.cost / 100)) < fee.costFixedMinimum)
                    return Number(fee.costFixedMinimum) + Number(fee.fixedPerTransaction);
                else
                    return Number(amount) * (fee.cost / 100) + fee.fixedPerTransaction;
            } else {
                return 0
            }
        }

        function onSelectProject(project) {
            setProjectUUID(project.uuid);
            setSelectedTerminal(null);
            setProviderUUID(null);
            setSelectedProject(project);
            setLoadingTerminals(true);
            setCommission(0);
            setTerminalBalance({balance: 0, currency: "RUB"});

            new Api({token}).getProjectData(project.uuid).then(
                (r) => {
                    if (r.terminals.length === 1) {
                        setTerminalBalance({balance: r.terminals[0].balance.confirmed, currency: r.terminals[0].currency})
                        setProviderUUID(r.terminals[0].uuid);
                        setSelectedTerminal(r.terminals[0]);
                        setCommission(calcCommission(form.amount, r.terminals[0].fee.payout));
                        setTotalFee(r.terminals[0].fee.payout);
                    }

                    setTerminals(r.terminals);
                    setLoadingTerminals(false);
                }
            )
        }

        function onSelectTerminal(terminal) {
            setSelectedTerminal(terminal);
            setProviderUUID(terminal.uuid);
            setTerminalBalance({balance: terminal.balance.confirmed, currency: terminal.currency})
            setTotalFee(terminal.fee.payout);

            if (form.amount.length > 0)
                setCommission(calcCommission(form.amount, terminal.fee.payout));
        }

        function onChangeForm(name, value) {
            setForm({...form, [name]: value});

            if (name === "amount")
                setCommission(calcCommission(value, totalFee))
        }

        function onSendForm() {

            if (projectUUID && providerUUID) {

                if (Number(terminalBalance.balance) < Number(form.amount) + Number(commission)) {
                    onMessage({type: 'warning', message: 'Недостаточно средств для выполнения операции.'})
                    return false;
                }

                if (form.pan && form.cardHolder && form.amount && (form.email || form.phone)) {
                    setIsRequest(true);

                    new Api({token}).makeSinglePayout(projectUUID, {...form, providerUUID}).then(
                        r => {
                            if (r.error && r.transactionId) {

                                onMessage({
                                    type: 'warning',
                                    message: 'Операция создана. ID операции для отслеживания: ' + r.transactionId
                                });
                                setForm({pan: '', cardHolder: '', email: '', phone: '', amount: ''});
                                setCommission(0);

                            } else if (!r.error && r.transactionId) {

                                onMessage({
                                    type: 'success',
                                    message: 'Успех! Денежные средства отправлены получателю. ID операции для отслеживания: ' + r.transactionId
                                })
                                setForm({pan: '', cardHolder: '', email: '', phone: '', amount: ''});
                                setCommission(0);

                            } else if (r.code) {

                                onMessage({type: 'error', message: 'code ' + r.code + ': ' + r.message});

                            } else {
                                onMessage({
                                    type: 'error',
                                    message: "Упс! Что-то пошло не так. Подождите некоторое время и попробуйте снова."
                                });
                            }

                            setIsRequest(false);
                        }
                    )
                } else {
                    onMessage({type: 'warning', message: 'Заполните все поля и укажите телефон или email получателя чека.'})
                }

            } else {
                onMessage({
                    type: 'warning',
                    message: 'Для отправки платежа выберите проект и терминал с баланса которого будут списаны средства.'
                })
            }
        }

        return (
            <Wrapper>
                <Container className={classes.StackOnMobile}>
                    <Column width="780" className={classes.MainColumn}>
                        <EmptyCard title="Pay.title.oneTimePayment">
                            <div className={classes.Block}>
                                <div className={classes.Col_1}>
                                    <h4 className={classes.BlockTitle}><FormattedMessage
                                        id="Pay.label.transferRecipient" defaultMessage="Получатель перевода"/>
                                    </h4>
                                </div>

                                <div className={classes.Col_2}>
                                    <CardNumberInputHelper onChange={onChangeForm} value={form.pan}
                                                           placeholder={"0000 0000 0000 0000 000"}
                                                           isDisabled={isRequest}/>
                                </div>

                                <div className={classes.Col_3}>
                                    <InputHelper
                                        onChange={onChangeForm}
                                        value={form.cardHolder}
                                        placeholder={"IVAN IVANOV"}
                                        fieldName={"cardHolder"}
                                        label={"FieldsHelper.label.cardholder"}
                                        changeRegexp={/[^A-Za-z\s]+/g}
                                        blurRegexp={/([A-Z]+\s)+([A-Z]+)/ig}
                                        changeMessage={"FieldsHelper.error.onlyLatinCardholder"}
                                        blurMessage={"FieldsHelper.error.checkCardholderName"}
                                        isUppercase
                                        isDisabled={isRequest}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>

                            <div className={classes.Divider}/>

                            <div className={classes.Block}>
                                <div className={classes.Col_1}>
                                    <h4 className={classes.BlockTitle}><FormattedMessage
                                        id="Pay.label.receiverCheck" defaultMessage="Получатель чека"/></h4>
                                </div>

                                <div className={classes.Col_2}>
                                    <InputHelper
                                        onChange={onChangeForm}
                                        value={form.email}
                                        placeholder={"example@email.ru"}
                                        fieldName={"email"}
                                        label={"FieldsHelper.label.email"}
                                        changeRegexp={/[^A-Za-z0-9\s_@.]+/g}
                                        blurRegexp={/^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/}
                                        changeMessage={"FieldsHelper.error.charactersEmail"}
                                        blurMessage={"FieldsHelper.error.checkEmail"}
                                        isDisabled={isRequest}
                                        autoComplete="off"
                                    />

                                </div>

                                <div className={classes.Col_3}>

                                    <InputHelper onChange={onChangeForm}
                                                 value={form.phone}
                                                 placeholder={"+79175744444"}
                                                 fieldName={"phone"}
                                                 label={"FieldsHelper.label.phone"}
                                                 changeRegexp={/[^0-9+]+/g}
                                                 blurRegexp={/^[+]\d+$/g}
                                                 changeMessage={"FieldsHelper.error.onlyNumbersPhone"}
                                                 blurMessage={"FieldsHelper.error.checkPhone"}
                                                 isDisabled={isRequest}
                                                 autoComplete="off"
                                    />

                                </div>
                            </div>

                            <div className={classes.Divider}/>

                            <div className={classes.Block}>
                                <div className={classes.Col_1}>
                                    <h4 className={classes.BlockTitle}><FormattedMessage id="Pay.label.amount"
                                                                                         defaultMessage="Сумма"/>
                                    </h4>
                                </div>

                                <div className={classes.Col_2}>

                                    <InputAmountCurrencyHelper
                                        onChange={onChangeForm}
                                        value={form.amount}
                                        currency={[terminalBalance.currency]}
                                        placeholder={"1960.20"}
                                        label={"FieldsHelper.label.amount"}
                                        changeMessage={"FieldsHelper.error.onlyNumbersAmount"}
                                        blurMessage={"FieldsHelper.error.checkAmount"}
                                        isDisabled={isRequest}
                                        autoComplete="off"
                                    />

                                </div>
                            </div>
                        </EmptyCard>
                    </Column>

                    <Column width="350" className={classes.SideColumn}>
                        <EmptyCard>
                            <Select
                                label={"FieldsHelper.label.project"}
                                placeholder={"FieldsHelper.label.selectProject"}
                                isLoading={loadingProjects || isRequest}
                                values={projects}
                                onChange={onSelectProject}
                                selectedValue={selectedProject}
                                fieldName={"displayName"}
                                fieldStatus={"status"}
                            />

                            <Select
                                label={"FieldsHelper.label.terminal"}
                                placeholder={"FieldsHelper.label.selectTerminal"}
                                isLoading={loadingProjects || !selectedProject || loadingTerminals}
                                values={terminals}
                                onChange={onSelectTerminal}
                                selectedValue={selectedTerminal}
                                isClean={false}
                                fieldName={"name"}
                                fieldStatus={"enabled"}
                            />
                        </EmptyCard>

                        <PayControls
                            pan={form.pan}
                            name={name}
                            cardHolder={form.cardHolder}
                            phone={form.phone}
                            email={form.email}
                            amount={form.amount ? form.amount : 0}
                            commission={commission}
                            balance={terminalBalance}
                            onSendForm={onSendForm}
                            isLoading={isRequest}
                        />
                    </Column>
                </Container>
            </Wrapper>
        )
    }
)



// WEBPACK FOOTER //
// ./src/PagesOfUser/Pay/index.js